import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

import 'swiper/css/bundle'

const sliderWorksheetsPdf = () => {
  let swiper

  function initSwiper () {
    const screenWidth = document.documentElement.clientWidth

    if (screenWidth < 768 && swiper === undefined) {
      swiper = new Swiper('#worksheets-pdf', {
        modules: [Navigation],
        grabCursor: true,
        speed: 800,
        slidesPerView: 1,
        spaceBetween: 8,
        navigation: {
          nextEl: '#worksheets-pdf .navigation .navigation-button-next',
          prevEl: '#worksheets-pdf .navigation .navigation-button-prev'
        },
        breakpoints: {
          600: {
            slidesPerView: 2,
            spaceBetween: 16
          }
        }
      })
    } else if (screenWidth > 767 && swiper !== undefined) {
      swiper.destroy(true, true)
      swiper = undefined
      document.querySelector('#worksheets-pdf .swiper-wrapper').removeAttribute('style')
      document.querySelector('#worksheets-pdf .swiper-slide').removeAttribute('style')
    }
  }
  initSwiper()
  window.addEventListener('resize', function () {
    initSwiper()
  })
}

export default sliderWorksheetsPdf
